import { call, put } from 'redux-saga/effects';
import { api, notify } from 'services';
import { IUpdateRequest } from 'interfaces/update-duck';
import { requestErrorHandler } from 'utils';
import { UpdatePickingActions } from 'store/ducks/pickings';

export function* updatePickingRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.put,
      `/pickings/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdatePickingActions.success(data));
    notify('success', 'Picking atualizado com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(UpdatePickingActions.failure(errorMessage));
  }
}
